/* ==========================================================================
   WarGrounds — barre d'achat collante, pilotage mobile

   Le theme n'affiche la barre que lorsque le bloc d'achat est passe AU-DESSUS
   de l'ecran (rect.bottom < 0). Sur telephone, le bloc d'achat est sous la
   ligne de flottaison au chargement : il n'est donc ni au-dessus, ni visible,
   et la barre reste cachee pendant tout le premier ecran — exactement la ou
   le visiteur decide s'il reste ou s'il part.

   On remplace le critere par le bon : la barre s'affiche des que le CTA reel
   n'est pas a l'ecran, qu'il soit au-dessus ou en dessous.
   Le basculement se fait par une classe sur <body> ; c'est la feuille
   wg-mobile-fiche.css qui decide de l'apparence, et elle ne le fait que sous
   749 px. Le comportement bureau n'est pas touche.

   Pour tout annuler : retirer la ligne script de wg-mobile-cro.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var bar = document.querySelector('[data-wg-sticky-buy]');
  var buy = document.querySelector('[data-wg-buy]');
  if (!bar || !buy) return;

  /* Reserve la hauteur de la barre en bas de page : la regle
     body.template-product du theme ne s'applique pas, le body ne porte pas
     cette classe (padding mesure : 0). On pose la notre, qui est toujours juste. */
  document.body.classList.add('wg-has-stickybuy');

  if (!('IntersectionObserver' in window)) {
    document.body.classList.add('wg-buy-offscreen');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      document.body.classList.toggle('wg-buy-offscreen', !e.isIntersecting);
    });
  }, { threshold: 0 });

  io.observe(buy);
})();
